import {helpers} from 'vuelidate/lib/validators'

// validator for user name
export const userName =
  helpers.regex ('userName', /^[A-Za-z][A-Za-z0-9.-]{0,30}[A-Za-z0-9]$/)
